module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_pp2_7.72accc43.png";